export default __webpack_public_path__ + "static/media/walkthru-shop.0f1950b7.svg";